import { useEffect } from "react";
import {
	createRoutesFromChildren,
	matchRoutes,
	useLocation,
	useNavigationType,
} from "react-router";

import * as Config from "./AppConfiguration.json";
import * as Sentry from "@sentry/react";

import { SATOSPortal } from "@/DataAdapter/SATOSPortal";

SATOSPortal.GetApplicationFeatures().then((applicationFeatures) => {
	const isEnabled = applicationFeatures?.Sentry ?? false;

	Sentry.init({
		dsn: Config.SENTRY_DSN,
		// release: import.meta.env.VITE_RELEASE_VERSION,
		enabled: true,
		environment: "development",
		integrations: [
			Sentry.reactRouterV6BrowserTracingIntegration({
				useEffect,
				useLocation,
				useNavigationType,
				createRoutesFromChildren,
				matchRoutes,
			}),
			Sentry.replayIntegration(),
			Sentry.feedbackIntegration({
				// Additional SDK configuration goes in here, for example:
				autoInject: false,
				colorScheme: "light",
				triggerLabel: "Send feedback",
				showBranding: false,
				enableScreenshot: Config.Environment === "development",
			}),
		],
		// Tracing
		tracesSampleRate: isEnabled ? 0.1 : 0, //  Capture 100% of the transactions
		// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
		tracePropagationTargets: ["localhost", "https://devtest.satos.no/api"],
		// Session Replay
		replaysSessionSampleRate: isEnabled ? 0.1 : 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
		replaysOnErrorSampleRate: isEnabled ? 1.0 : 0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
		beforeSend(event) {
			event.tags = {
				...event.tags,
				environment: window.location.hostname,
			};

			if (event.type === "feedback") {
				return event; // Always send feedback events
			}

			// Prevent events from being sent when running on localhost
			if (window.location.hostname === "localhost" || !isEnabled) {
				return null; // Drop the event
			}

			return event; // Send the event
		},
	});
});
